import { Grid } from "@mui/material";
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";

import { useAxios } from "../../hooks";
import { colors } from "../css components/Style";
import List from "./unverified agencies list/List";
import { PageHeader, Pagination } from "../../components";
import { CancelButton } from "../css components/Button";

export default function UnverifiedAgenciesList() {
  const axios = useAxios();
  const navigate = useNavigate();
  const { state } = useLocation();
  const platformID = queryString.parse(window.location.search).platformID;

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState({
    page: 1,
    totalCount: 0,
    lastCount: 0,
    itemsPerPage: 10,
  });
  const [agencies, setAgencies] = useState([]);
  const [sortBy, setSortBy] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [agencyStatus, setAgencyStatus] = useState();
  const [categorize, setCategorize] = useState(platformID);

  let sortList = [
    { value: "", label: "All", color: colors.blue },
    { value: 1, label: "Verified", color: colors.green },
    { value: 0, label: "Unverified", color: colors.yellow },
    { value: 2, label: "Rejected", color: colors.error },
  ];

  useEffect(() => {
    setLoading(true);

    axios({
      url:
        "/getAllAgency?page=" +
        page.page +
        "&limit=10" +
        (sortBy !== "" ? "&is_agency_verified=" + sortBy : "") +
        (categorize !== "" ? "&platform_id=" + categorize : "") +
        (Boolean(searchKey) ? "&search=" + encodeURIComponent(searchKey) : ""),
      method: "GET",
      disableRedirect: false,
    }).then((response) => {
      if (response.status) {
        setAgencies(response.data.parsedAgency);

        setPage((prev) => ({
          ...prev,
          totalCount: response.data.totalCount,
          lastPage: response.data.campaignData?.length < 10,
        }));
      } else {
        setAgencies([]);

        setPage((prev) => ({
          ...prev,
          totalCount: response.data.totalCount,
          lastPage: response.data.campaignData?.length < 10,
        }));
      }
      setLoading(false);
    });
  }, [
    axios,
    categorize,
    agencyStatus,
    page.page,
    sortBy,
    platformID,
    searchKey,
  ]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      ...prev,
      page: step === "index" ? index : prev.page + (step === "next" ? 1 : -1),
    }));
  }
  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid size={12}>
          <PageHeader
            pageName={"Agencies"}
            pageHeader={"List of agencies"}
            buttons={[
              state?.component === "platform" && (
                <CancelButton variant="outlined" onClick={() => navigate(-1)}>
                  Back
                </CancelButton>
              ),
            ]}
          />
        </Grid>
      </Grid>

      <List
        platformID={platformID}
        sortList={sortList}
        setSortBy={setSortBy}
        sortBy={sortBy}
        loading={loading}
        setPage={setPage}
        setSearchKey={setSearchKey}
        agencies={agencies}
        categorize={categorize}
        setCategorize={setCategorize}
        setAgencyStatus={setAgencyStatus}
      />
      {!!page.totalCount && (
        <Grid item container display={"flex"} justifyContent={"center"}>
          <Pagination
            style={{ marginTop: "20px" }}
            count={Math.ceil(page.totalCount / 10)}
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
